/**
 * @module ヘッダー部共通コンポーネント
 */
import NativeApi from '../../api/nativeApi';
import NativeCallback from '../../api/nativeCallback';
import ExternalUrl from '../../api/externalLinks/externalUrls';

export default {
  props: {
    displayName: {
      type: String,
      default: '',
      required: false,
    },
    hintText: {
      type: String,
      default: '',
      required: false,
    },
    reloadFlag: {
      type: Boolean,
      default: false,
      required: false,
    },
    marginBottom: {
      type: Number,
      default: 30,
      required: false,
    },
    isMenuItemsVisible: {
      type: Boolean,
      default: true,
      required: false,
    },
    languageOnly: {
      type: Boolean,
      default: false,
      required: false,
    },
    displayBackButton: {
      type: Boolean,
      default: true,
      required: false,
    },
    displayCenterLogo: {
      type: Boolean,
      default: false,
      required: false,
    },
    backAddress: {
      type: String,
      default: '',
      required: false,
    },
    ancestorId: {
      type: Number,
      default: null,
      required: false,
    },
    pageLeaveConfirm: {
      type: Function,
      default: null,
      required: false,
    },
  },
  data: function (vm) {
    return {
      id: '',
      isEnglish: false,
      nativeCallbackResult: {
        errorCode: '',
      },
      notificationPriority: 0,
      hintImage: require('../../assets/images/icon/hint.png'),
      reloadImage: require('../../assets/images/icon/reload.png'),
      alertBellImage: '',
      nav: [
        {
          id: 0,
          text: vm.$vuetify.lang.t('$vuetify.FECU02トップ画面.トップ'),
          img: require('../../assets/images/header_right/tops.svg'),
          router: '/top',
          alt: 'トップ',
        },
        {
          id: 1,
          text: vm.$vuetify.lang.t('$vuetify.FECU02トップ画面.通知履歴'),
          img: require('../../assets/images/header_right/notification-historys.svg'),
          router: '/notificationHistory',
          alt: '通知履歴',
        },
        {
          id: 2,
          text: vm.$vuetify.lang.t('$vuetify.FECU02トップ画面.設定'),
          img: require('../../assets/images/header_right/settings.svg'),
          router: '/variousSettings',
          alt: '設定',
        },
        {
          id: 3,
          text: 'English',
          img: require('../../assets/images/header_right/language.svg'),
          router: '/language',
          alt: 'English',
        },
        {
          id: 4,
          text: vm.$vuetify.lang.t('$vuetify.FECU02トップ画面.ユーザーマニュアル'),
          img: require('../../assets/images/header_right/user-manual.svg'),
          router: 'https://www.google.co.jp/',
          alt: 'ユーザーマニュアル',
        },
        {
          id: 5,
          text: vm.$vuetify.lang.t('$vuetify.FECU02トップ画面.通販ショップ'),
          img: require('../../assets/images/header_right/shop.svg'),
          router: 'https://guardman-shop.com',
          alt: '通販ショップ',
        },
        {
          id: 6,
          text: vm.$vuetify.lang.t('$vuetify.FECU02トップ画面.利用規約'),
          img: require('../../assets/images/header_right/terms.svg'),
          router: '/terms',
          alt: '利用規約',
        },
        {
          id: 7,
          text: vm.$vuetify.lang.t('$vuetify.FECU02トップ画面.プライバシーポリシー'),
          img: require('../../assets/images/header_right/privacy-policy.svg'),
          router: '/privacy',
          alt: 'プライバシーポリシー',
        },
        {
          id: 8,
          text: vm.$vuetify.lang.t('$vuetify.FECU02トップ画面.ライセンス情報'),
          img: require('../../assets/images/header_right/license.svg'),
          router: '/license',
          alt: 'ライセンス情報',
        },
        {
          id: 9,
          text: vm.$vuetify.lang.t('$vuetify.FECU02トップ画面.ログアウト'),
          img: require('../../assets/images/header_right/logout.svg'),
          router: '/logout',
          alt: 'ログアウト',
        },
      ],
      uiVersion: '',
      copyRight: 'Copyright Ⓒ 2008 - 2022 ALSOK. All rights reserved.',
      isLong: false,

      //いずれ定数一覧に移動
      colorType1: 1,
      colorType2: 2,
      colorType3: 3,
    };
  },
  computed: {
    i18nItems(vm) {
      return {
        nav: [
          {
            id: 0,
            text: 'English',
            img: require('../../assets/images/header_right.svg') + '#language',
            router: this.returnLanguage,
            alt: 'English',
            show: true,
          },
          {
            id: 1,
            text: vm.$vuetify.lang.t('$vuetify.FECU02トップ画面.トップ'),
            img: require('../../assets/images/top/icon_top.png'),
            router: this.returnTop,
            alt: 'トップ',
            show: true,
          },
          {
            id: 2,
            text: vm.$vuetify.lang.t('$vuetify.FECU02トップ画面.通知履歴'),
            img: require('../../assets/images/top/icon_notification.png'),
            router: this.returnNotificationHistory,
            alt: '通知履歴',
            show: true,
          },
          {
            id: 3,
            text: vm.$vuetify.lang.t('$vuetify.FECU02トップ画面.ホームセキュリティ'),
            img: require('../../assets/images/top/icon_homeSecurity.png'),
            router: this.returnDisplayDistrict,
            alt: 'ホームセキュリティ',
            show:
              this.$store.state.isTopHomeSecurityActive &&
              !this.$store.state.disableHomeSecurityActive,
          },
          {
            id: 4,
            text: vm.$vuetify.lang.t('$vuetify.FECU02トップ画面.カメラ'),
            img: require('../../assets/images/top/icon_camera.png'),
            router: this.returnCamera,
            alt: 'カメラ',
            show: this.$store.state.isTopCameraActive && !this.$store.state.disableCamera,
          },
        ],
        sideNav: [
          {
            id: 0,
            text: vm.$vuetify.lang.t('$vuetify.FECU02トップ画面.トップ'),
            img: require('../../assets/images/header_right.svg') + '#tops',
            router: '/top',
            alt: 'トップ',
            show: true,
          },
          {
            id: 1,
            text: vm.$vuetify.lang.t('$vuetify.FECU02トップ画面.通知履歴'),
            img: require('../../assets/images/header_right.svg') + '#notification-historys',
            router: '/notificationHistory',
            alt: '通知履歴',
            show: true,
          },
          {
            id: 2,
            text: vm.$vuetify.lang.t('$vuetify.FECU02トップ画面.設定'),
            img: require('../../assets/images/header_right.svg') + '#settings',
            router: '/variousSettings',
            alt: '設定',
            show: true,
          },
          {
            id: 3,
            text: 'English',
            img: require('../../assets/images/header_right.svg') + '#language',
            router: '/language',
            alt: 'English',
            show: true,
          },
          {
            id: 4,
            text: vm.$vuetify.lang.t('$vuetify.FECU02トップ画面.ユーザーマニュアル'),
            img: require('../../assets/images/header_right.svg') + '#user-manual',
            router: 'https://www.google.co.jp/',
            alt: 'ユーザーマニュアル',
            show: true,
          },
          {
            id: 5,
            text: vm.$vuetify.lang.t('$vuetify.FECU02トップ画面.通販ショップ'),
            img: require('../../assets/images/header_right.svg') + '#shop',
            router: 'https://guardman-shop.com',
            alt: '通販ショップ',
            show: true,
          },
          {
            id: 6,
            text: vm.$vuetify.lang.t('$vuetify.FECU02トップ画面.利用規約'),
            img: require('../../assets/images/header_right.svg') + '#terms',
            router: '/terms',
            alt: '利用規約',
            show: true,
          },
          {
            id: 7,
            text: vm.$vuetify.lang.t('$vuetify.FECU02トップ画面.プライバシーポリシー'),
            img: require('../../assets/images/header_right.svg') + '#privacy-policy',
            router: '/privacy',
            alt: 'プライバシーポリシー',
            show: true,
          },
          {
            id: 8,
            text: vm.$vuetify.lang.t('$vuetify.FECU02トップ画面.ライセンス情報'),
            img: require('../../assets/images/header_right.svg') + '#license',
            router: '/license',
            alt: 'ライセンス情報',
            show: true,
          },
          {
            id: 9,
            text: vm.$vuetify.lang.t('$vuetify.FECU02トップ画面.ログアウト'),
            img: require('../../assets/images/header_right.svg') + '#logout',
            router: '/logout',
            alt: 'ログアウト',
            show: true,
          },
        ],
      };
    },
    version() {
      if (this.$isMobileApp) {
        return (
          'App Ver: ' +
          this.$store.getters['appInfo/getNativeVersion'] +
          '/ UI Ver: ' +
          this.uiVersion
        );
      } else {
        return 'Ver: ' + this.uiVersion;
      }
    },
  },
  /** @type {Methods} */
  methods: {
    returnLanguage() {
      this.$router.push('/language');
    },
    /**
     * トップボタン押下時処理
     */
    returnTop() {
      this.$router.push('/top');
    },
    /**
     * 通知履歴ボタン押下時処理
     */
    returnNotificationHistory() {
      this.$store.commit('setFromType', { fromType: 0 });
      this.$router.push('/notificationHistory');
    },
    /**
     * ホームセキュリティボタン押下時処理
     */
    returnDisplayDistrict() {
      if (this.$store.state.districtOneCountFlag) {
        // 対象地区が1地区の場合、対象地区詳細画面に遷移する。
        this.$store.commit('setCustomerNumber', {
          customerNumber: this.$store.state.oneDistrictCustomerNumber,
        });
        this.$store.commit('setDistrictSplitNumber', {
          districtSplitNumber: this.$store.state.oneDistrictSplitNumber,
        });
        this.$router.push('/displayDistrictDetail');
      } else {
        // 対象地区が2地区以上存在するの場合、ホームセキュリティ画面に遷移する。
        this.$router.push('/homeSecurity');
      }
    },
    /**
     * カメラボタン押下時処理
     */
    returnCamera() {
      if (this.$store.state.cameraOneCountFlag) {
        // カメラが1台の場合、カメラ詳細画面に遷移する。
        this.$store.commit('setCustomerNumber', {
          customerNumber: this.$store.state.oneCameraCustomerNumber,
        });
        this.$store.commit('setDeviceID', {
          deviceID: this.$store.state.oneCameraDeviceID,
        });
        this.$router.push('/cameraDetail');
      } else {
        // カメラが2台以上の場合、カメラ画面に遷移する。
        this.$router.push('/camera');
      }
    },
    /**
     * ユーザーマニュアルボタン押下時処理
     */
    goOpenManual() {
      let displayLang = localStorage.getItem('lang');
      let manualUri = displayLang === 'en' ? ExternalUrl.manualEn : ExternalUrl.manual;
      if (this.$isMobileApp) {
        NativeApi.openBrowserApp(manualUri);
      } else {
        window.open(manualUri, '_blank');
      }
    },
    /**
     * 通販ショップボタン押下時処理
     */
    goOnlineShop() {
      if (this.$isMobileApp) {
        NativeApi.openBrowserApp(ExternalUrl.shop);
      } else {
        window.open(ExternalUrl.shop, '_blank');
      }
    },
    /**
     * 戻るボタン押下時処理
     * @param {String} path
     */
    goBack(path) {
      if (path !== '') {
        // 指定先があれば指定に戻る
        this.$router.push({
          path: `/${path}`,
        });
      } else {
        this.$_setGoBack(true);
        this.$router.back();
      }
    },
    /**
     * ログアウトボタン押下時処理
     */
    async logout() {
      if (typeof this.pageLeaveConfirm === 'function' && !(await this.pageLeaveConfirm())) {
        return;
      }
      this.$_setLoading(true);
      setTimeout(async () => {
        await this.$_APP_CU0202();
      }, 2000);
    },
    /**
     * 言語切り替えボタン押下時処理
     */
    changeLang() {
      this.$vuetify.lang.current = this.$vuetify.lang.current === 'en' ? 'ja' : 'en';
      localStorage.setItem('lang', this.$vuetify.lang.current);
      this.isEnglish = this.isEnglish === true ? false : true;
      if (this.$isMobileApp) {
        NativeApi.registerLanguageSetting(this.$vuetify.lang.current);
        // IF09_言語設定記録要求（NativeApi.registerLanguageSetting）のコールバック結果はwatchで監視する
      }

      this.$emit('change-lang', this.$vuetify.lang.current);
    },
    /**
     * CU0201のAPI実行処理
     * @returns apiData レスポンスデータ
     */
    APP_CU0201: async function () {
      let param = '/api/commonHeaderFooter/getAlarmInfo';

      let queries = {
        token: sessionStorage.getItem('token'), // JWTトークン sessionStorageから取得
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '', //端末情報 localStorageから取得
      };

      let method = 'post';

      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     notificationPriority: 1, // 0:指定なし 1:青 2:黄 3:赤
            //   },
            // };

            // 警報ベルの表示
            this.notificationPriority = apiData.contentsInfo.notificationPriority;

            // image切替
            if (this.notificationPriority == this.colorType1) {
              // 青
              this.alertBellImage = require('../../assets/images/icon/header-alert-bell_blue.svg');
            } else if (this.notificationPriority == this.colorType2) {
              // 黄
              this.alertBellImage = require('../../assets/images/icon/header-alert-bell_yellow.svg');
            } else if (this.notificationPriority == this.colorType3) {
              // 赤
              this.alertBellImage = require('../../assets/images/icon/header-alert-bell_red.svg');
            }
          },
          (error) => {
            this.$_abnormality(error.response.status);
          }
        );
      // console.log("APP_CU0201>>>", apiData);

      return apiData;
    },
    /**
     * 画面リロード
     */
    reset: function () {
      // this.$router.go({ path: this.$router.currentRoute.path, force: true });
      window.location.reload();
    },
    /**
     * ヘルプ文言ダイアログ表示
     */
    async callHelpDialog() {
      await this.$helpDialog(
        '$vuetify.messageDialog.ヘルプ',
        this.hintText,
        '$vuetify.messageDialog.OK'
      );
    },
    /**
     * 画面遷移処理
     * @param {String} path 画面遷移先パス
     */
    routerPush: function (path) {
      if (path == '/notificationHistory') {
        // 通知履歴遷移前に設定
        this.$store.commit('setFromType', { fromType: 0 });
      }
      if (this.$route.path !== path) {
        this.$router.push({ path: path });
      }
    },
  },
  beforeMount() {
    // IF09を登録
    window.onRegisterLanguageSettingFinished = (error) => {
      this.nativeCallbackResult = NativeCallback.onRegisterLanguageSettingFinished(error);
    };
  },
  watch: {
    // IF09の結果を監視
    nativeCallbackResult(newValue) {
      if (NativeCallback.codeInclude(newValue.errorCode, '09-E9999')) {
        this.$router.replace({
          path: '/sorry',
          //query: { hoge_token: data }
        });
      }
    },
    deep: true,
  },
  async mounted() {
    this.$_setGoBack(false);

    // versionファイルの取得
    const file = require('raw-loader!@/../public/version');
    this.uiVersion = file.default;

    // 表示言語切り替え処理
    var str = localStorage.getItem('lang');
    if (str) {
      // localStorageに表示言語が保存されている場合
      this.$vuetify.lang.current = str;
      if (str == 'ja') {
        // 日本語のとき
        this.isEnglish = false;
      } else {
        this.isEnglish = true;
      }
    }

    // title幅調整
    if (this.displayName.length > 3) {
      this.isLong = true;
    }
  },
};
